import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import injectStyles from 'react-jss'

import { authorization } from 'Module/Auth/Auth'
import ImportMissions from './../../RosterView/ImportMissions'
import { Modal } from './../../../../Components/Modal'
import {
  convertMissionDtoToMissionMasterSchedule,
  downloadSampleCSV,
  validateMissionDtoMasterSchedule,
} from './util'
import DataFetchingTableTable from '../../../../Components/DataFetchingTableTable'
import { normalizeGraphQLConnection } from '../../../../shared/graphql/utils'
import { filterLocationName } from '../../utils'
import { handleConfirmationDialog } from '../../../City/Page/Ambasadors/EmailPipelineView/utils'
import ConfirmDialog from '../../../../Components/ConfirmDialog/ConfirmDialog'
import ButtonDropdown from '../../../../Components/ButtonDropdown'
import CoreOutlinedButton from '../../../Home/components/CoreOutlinedButton'
import ColorCircularProgress from '../../../../Components/ColorCircularProgress'
import {
  CAMPAIGN_ENUM_TYPES,
  LOCATION_STATUS_ENUM,
} from '../../../../shared/constants'

const styles = {
  wrapperTable: {
    width: '100%',
    overflowY: 'auto',
  },
  container: {
    '& .SearchAndFilters': {
      marginLeft: 50,
      marginRight: 50,
      width: '100%',
    },
  },
  exportButton: {
    marginLeft: 10,
  },
}

const View = props => {
  const {
    header,
    sortOn,
    filterOn,
    onExportData,
    onMissionsImport,
    cityPlans,
    fetchData,
    getDataForMissionsImport,
    refreshRequestTrigger,
    brandAmbassadors,
    campaign,
    presets,
    isExportLoading,
    baRedirectActions,
    footerRender,
    isImportLoading,
  } = props

  const [showImportMissionsModal, setShowImportMissionsModal] = useState(false)
  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })

  const locations = cityPlans.reduce((acc, cityPlan) => {
    const locations = normalizeGraphQLConnection(
      cityPlan.city.locations,
    ).reduce((acc, location) => {
      if (location.status === LOCATION_STATUS_ENUM.ENABLED) {
        acc.push({ ...location, cityName: cityPlan.city.name })
      }
      return acc
    }, [])
    return [...acc, ...locations]
  }, [])

  const locationNames = filterLocationName(locations)
  const ambassadorNames = brandAmbassadors.map(b =>
    b ? b.firstName + ' ' + b.lastName : '-',
  )
  const cities = cityPlans.map(c => c.city)

  const validateRow = dto => {
    return validateMissionDtoMasterSchedule(dto, {
      locations,
      ambassadorNames,
      cities,
      campaignType: campaign.type,
      artworksIds: campaign.artworksLean.map(artwork => artwork.id),
    })
  }

  const localOnMissionsImport = async (missions, onProgress) => {
    await onMissionsImport(
      missions.map(dto => {
        return convertMissionDtoToMissionMasterSchedule(dto, {
          locations,
          ambassadors: brandAmbassadors,
          cityPlans,
          type: campaign.type,
        })
      }),
      onProgress,
      campaign.id,
    )
    setShowImportMissionsModal(false)
  }

  const downloadCSV = () =>
    downloadSampleCSV({
      locationNames,
      cityNames: cities.map(c => c.name),
      ambassadorNames,
      isNeedToAddTagColumn: CAMPAIGN_ENUM_TYPES.DIRECTMAIL === campaign.type,
      campaignType: campaign.type,
    })

  const handleOpenImportModal = async () => {
    if (campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually import mission for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      await getDataForMissionsImport()
      setShowImportMissionsModal(true)
    }
  }
  const options = [
    {
      label: 'Export all missions',
      onClick: () => {
        onExportData({ isExportAllMissions: true })
      },
    },
    {
      label: 'Export only checked-out missions',
      onClick: () => {
        onExportData({ isExportAllMissions: false })
      },
    },
  ]

  return (
    <div className={props.classes.container}>
      {confirmDialogData.isOpen ? (
        <ConfirmDialog {...confirmDialogData} />
      ) : null}
      <Box
        mt={2}
        mb={2}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        mr={5}
      >
        <Box component="span" mr={1}>
          {!(authorization.isClient() || authorization.isClientAdmin()) && (
            <CoreOutlinedButton
              icon={
                isImportLoading ? <ColorCircularProgress size={20} /> : null
              }
              disabled={isImportLoading}
              onClick={handleOpenImportModal}
              label="Import"
            />
          )}
        </Box>
        <Box component="span" ml={1}>
          <ButtonDropdown
            label="Export"
            disableStartIcon={true}
            disabled={isExportLoading}
            options={options}
            isLoading={isExportLoading}
          />
        </Box>
      </Box>

      <div className={props.classes.wrapperTable}>
        <DataFetchingTableTable
          showFilterPresets={true}
          filters={filterOn}
          fetchData={fetchData}
          enableMultiFilterValues={true}
          refreshRequestTrigger={refreshRequestTrigger}
          header={header}
          sortableHeaders={sortOn}
          showSearch={true}
          enableFilterSuggestions={true}
          presets={presets}
          baRedirectActions={baRedirectActions}
          footer={footerRender({ header: header })}
        />
      </div>
      <Modal show={showImportMissionsModal}>
        <ImportMissions
          onClose={() => setShowImportMissionsModal(false)}
          onImportSuccess={localOnMissionsImport}
          validateRow={validateRow}
          downloadSampleCSV={downloadCSV}
          isMasterSchedule={true}
        />
      </Modal>
    </div>
  )
}

export default injectStyles(styles)(View)
